var React = require('react');

function SocialsYoutube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.3458 3.17708C29.0167 1.92708 27.9747 0.9375 26.7132 0.625C24.3549 0 15.0313 0 15.0313 0C15.0313 0 5.6529 0 3.29458 0.625C2.03316 0.9375 0.991109 1.92708 0.662042 3.17708C0.00390625 5.36458 0.00390625 10.0521 0.00390625 10.0521C0.00390625 10.0521 0.00390625 14.6875 0.662042 16.9271C0.991109 18.1771 2.03316 19.1146 3.29458 19.4271C5.6529 20 15.0313 20 15.0313 20C15.0313 20 24.3549 20 26.7132 19.4271C27.9747 19.1146 29.0167 18.1771 29.3458 16.9271C30.0039 14.6875 30.0039 10.0521 30.0039 10.0521C30.0039 10.0521 30.0039 5.36458 29.3458 3.17708ZM11.96 14.2708V5.83333L19.748 10.0521L11.96 14.2708Z","fill":"#D16AA9"}));
}

SocialsYoutube.defaultProps = {"width":"31","height":"20","viewBox":"0 0 31 20","fill":"none"};

module.exports = SocialsYoutube;

SocialsYoutube.default = SocialsYoutube;
